/** The placeholder name an ingredient carries until it is named from its render or by the user. */
export const DEFAULT_INGREDIENT_NAME = 'ingredient';

/**
 * Ingredient names are tags in prompts and chat, so two cannot share one. A colliding name
 * gets the smallest `-N` suffix that keeps it unique, ignoring case.
 */
export function makeIngredientNameUnique(desired: string, takenNames: string[]): string {
    const taken = new Set(takenNames.map((name) => name.toLowerCase()));
    if (!taken.has(desired.toLowerCase())) {
        return desired;
    }
    let suffix = 2;
    while (taken.has(`${desired}-${suffix}`.toLowerCase())) {
        suffix += 1;
    }
    return `${desired}-${suffix}`;
}
